import {
  ActionSheetButton,
  IonActionSheet,
  IonItem,
  IonLabel,
  IonList,
  IonNote,
  IonText,
} from '@ionic/react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useBeaconRouter } from '../../route/route.hooks';
import {
  useDirectConnectCachedMachines,
  useRemoveDirectConnectCachedMachine,
} from '../cache/direct-connect-machine-cache';
import { DirectConnectMachine } from '../model/direct-connect.model';

const DirectConnectMachineSelect = () => {
  const { builder } = useBeaconRouter();
  const { i18n } = useTranslation();
  const { push } = useHistory();

  const [selectedMachine, setSelectedMachine] = useState<
    DirectConnectMachine | undefined
  >(undefined);

  const machines = useDirectConnectCachedMachines();
  const removeMachine = useRemoveDirectConnectCachedMachine();

  const actionSheetButtons = useMemo((): ActionSheetButton[] => {
    return [
      {
        text: i18n.t('common:connect'),
        handler: () => {
          if (selectedMachine) {
            push(builder.getMachineRoute('unknown', selectedMachine?.id));
          }
        },
      },
      {
        text: i18n.t('common:remove'),
        role: 'destructive',
        handler: () => {
          if (selectedMachine) {
            removeMachine(selectedMachine?.id);
          }
        },
      },
      {
        text: i18n.t('common:cancel'),
        role: 'cancel',
      },
    ];
  }, [i18n, removeMachine, selectedMachine, push, builder]);

  const noResultsActive = (
    <div className="full-height-width content-center">
      <IonText className="ion-padding ion-text-center" color="medium">
        <h2>{i18n.t('common:machine_add_new_message')}</h2>
      </IonText>
    </div>
  );

  const hasMachines = machines.length > 0;

  return (
    <>
      {!hasMachines && noResultsActive}
      <IonList>
        {machines.map((machine) => {
          return (
            <MachineRow
              key={machine.id}
              machine={machine}
              onClick={setSelectedMachine}
            />
          );
        })}
      </IonList>
      <IonActionSheet
        isOpen={selectedMachine !== undefined}
        onDidDismiss={() => setSelectedMachine(undefined)}
        buttons={actionSheetButtons}
      />
    </>
  );
};

interface MachineRowProps {
  machine: DirectConnectMachine;
  onClick: (machine: DirectConnectMachine) => void;
}

const MachineRow = (props: MachineRowProps) => {
  const { machine, onClick } = props;

  return (
    <IonItem
      style={{ '--min-height': '60px' }}
      onClick={() => {
        onClick(machine);
      }}
    >
      <IonLabel>{machine.name}</IonLabel>
      <IonNote slot="end">{machine.serialNumber}</IonNote>
    </IonItem>
  );
};

export { DirectConnectMachineSelect };
